// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"BookingFilter_pageTitle__1O7Pe"};